export enum ReassignmentQuickFilter {
  Reason = 'Reason',
  State = 'State'
}
